/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ success: NonNullable<unknown>, "duplicates, select, 0 {": NonNullable<unknown>, "⚠ {duplicates": NonNullable<unknown>, "failed, select, 0 {": NonNullable<unknown>, "✗ {failed": NonNullable<unknown> }} Preset_Manager_Import_Results_MessageInputs */

const en_preset_manager_import_results_message = /** @type {(inputs: Preset_Manager_Import_Results_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import complete:
✓ ${i?.success} preset(s) imported successfully
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
};

const fr_preset_manager_import_results_message = /** @type {(inputs: Preset_Manager_Import_Results_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importation terminee :
✓ ${i?.success} preset(s) importe(s) avec succes
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} doublon(s) renomme(s)
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) non importe(s)}}`)
};

const de_preset_manager_import_results_message = /** @type {(inputs: Preset_Manager_Import_Results_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import abgeschlossen:
✓ ${i?.success} Voreinstellung(en) erfolgreich importiert
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
};

const it_preset_manager_import_results_message = /** @type {(inputs: Preset_Manager_Import_Results_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione completata:
✓ ${i?.success} preset importati correttamente
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
};

const ru_preset_manager_import_results_message = /** @type {(inputs: Preset_Manager_Import_Results_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Импорт завершен:
✓ ${i?.success} пресеты успешно импортированы
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
};

const es_preset_manager_import_results_message = /** @type {(inputs: Preset_Manager_Import_Results_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importación completada:
✓ ${i?.success} ajustes preestablecidos importados correctamente
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
};

const zh_cn2_preset_manager_import_results_message = /** @type {(inputs: Preset_Manager_Import_Results_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入完成：
✓ ${i?.success} 预设已成功导入
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
};

const ja_preset_manager_import_results_message = /** @type {(inputs: Preset_Manager_Import_Results_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`インポートが完了しました:
✓ ${i?.success} プリセットが正常にインポートされました
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
};

const hi_preset_manager_import_results_message = /** @type {(inputs: Preset_Manager_Import_Results_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आयात पूर्ण:
✓ ${i?.success} प्रीसेट सफलतापूर्वक आयात किए गए
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
};

const pt_pt2_preset_manager_import_results_message = /** @type {(inputs: Preset_Manager_Import_Results_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importação concluída:
✓ ${i?.success} predefinições importadas com sucesso
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
};

/**
* | output |
* | --- |
* | "Import complete: ✓ {success} preset(s) imported successfully {duplicates, select, 0 {} other {⚠ {duplicates} duplicate(s) renamed }}{failed, select, 0 {} oth..." |
*
* @param {Preset_Manager_Import_Results_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_results_message = /** @type {((inputs: Preset_Manager_Import_Results_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_Results_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_import_results_message(inputs)
	if (locale === "de") return de_preset_manager_import_results_message(inputs)
	if (locale === "it") return it_preset_manager_import_results_message(inputs)
	if (locale === "ru") return ru_preset_manager_import_results_message(inputs)
	if (locale === "es") return es_preset_manager_import_results_message(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_import_results_message(inputs)
	if (locale === "ja") return ja_preset_manager_import_results_message(inputs)
	if (locale === "hi") return hi_preset_manager_import_results_message(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_import_results_message(inputs)
	return en_preset_manager_import_results_message(inputs)
});